<bw-action-article
  [minHeight]="200"
  [brightsideWebFb]="{ event_name: 'create_account_shown', custom: {'company': company}}">
  <typography title-medium header-title>
    {{ 'GET_STARTED_TODAY' | translate }}
  </typography>
  <div content-section>
    <bw-paragraph>{{ 'REGISTER_DESC' | translate }}</bw-paragraph>
    <div class="flex-column">
      <button bw-button (click)="signUpWithAuth0()">
        {{ 'REGISTER' | translate }}
      </button>
      <typography class="center mt-xs">
        {{ 'ALREADY_HAVE_ACCOUNT' | translate }}
        <a bw-anchor (click)="loginWithAuth0();"> {{ 'SIGN_IN' | translate }}</a>
      </typography>
    </div>
  </div>
</bw-action-article>

